import { SettingsSection } from '@chatsdet/ui';
import { SessionSeedsEditor } from '../../CredentialForm';
import { SectionSaveFooter } from '../SectionSaveFooter';
import { usePropertySection } from '../usePropertySection';

/**
 * Where this app keeps its authenticated session. Consumed by minted-session
 * credentials to synthesize a storage state instead of driving a login UI.
 */
export function SessionStateSection({ propertyId }: { propertyId: string }) {
  const section = usePropertySection<{ sessionSeeds: unknown }>({
    propertyId,
    select: (p) => ({ sessionSeeds: p.sessionSeeds ?? undefined }),
    // undefined means "cleared" — send null so the column is emptied
    toPatch: (d) => ({ sessionSeeds: d.sessionSeeds ?? null }),
  });

  if (section.isLoading) return null;

  return (
    <SettingsSection
      title="Session & Storage State"
      description="Lets a token credential write a freshly minted session straight into storage state, skipping the login UI."
      footer={
        section.isDirty ? (
          <SectionSaveFooter
            isSaving={section.isSaving}
            onSave={section.save}
            onDiscard={section.discard}
          />
        ) : null
      }
    >
      <SessionSeedsEditor
        scope="property"
        value={section.draft.sessionSeeds}
        onChange={(seeds) => section.setDraft(() => ({ sessionSeeds: seeds }))}
      />
    </SettingsSection>
  );
}
